import {FeaturesEnum} from 'presentation/constants';
import {MY_HOSPITALIZATION_FEATURE_BY_HOST} from 'presentation/constants/myHospitalizationFeatureByHost';
import {useHostName} from 'presentation/hooks';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';

export const useMyHospitalizationFeatureFlag = () => {
	const {
		dataHostNameState: {product},
		isLinha,
	} = useHostName();

	const flagName = isLinha
		? FeaturesEnum.PORTAL_FEATURE_MA_LINHA
		: MY_HOSPITALIZATION_FEATURE_BY_HOST[product];
	const {isEnabled} = useFeatureFlag(flagName);

	return {
		isEnabled,
	};
};
